<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">

      <el-form-item label="文件类型代码(字典)" prop="fileTypeCode">
        <el-select v-model="dataForm.fileTypeCode" placeholder="请选择" style="width:100%">
          <el-option v-for="item in fileTypeData" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>

      </el-form-item>

      <el-form-item label="客户编号" prop="custCode">
        <el-input v-model="dataForm.custCode" placeholder="客户编号"></el-input>
      </el-form-item>

      <el-form-item label="附件路径" prop="attcUrl">
        <el-input v-model="dataForm.attcUrl" placeholder="附件路径"></el-input>
      </el-form-item>

      <el-form-item label="版本号" prop="version">
        <el-input v-model="dataForm.version" placeholder="版本号"></el-input>
      </el-form-item>

      <el-form-item label="备注" prop="remark">
        <el-input v-model="dataForm.remark" placeholder="备注"></el-input>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from "lodash/debounce"
export default {
  data() {
    return {
      visible: false,
      fileTypeData: [],
      dataForm: {
        id: "",
        fileTypeCode: "",
        custCode: "",
        attcUrl: "",
        createTime: "",
        createBy: "",
        updateTime: "",
        updateBy: "",
        version: "",
        remark: "",
      },
    }
  },
  computed: {
    dataRule() {
      return {
        fileTypeCode: [{ required: true, message: this.$t("validate.required"), trigger: "blur" }],
        custCode: [{ required: true, message: this.$t("validate.required"), trigger: "blur" }],
        attcUrl: [{ required: true, message: this.$t("validate.required"), trigger: "blur" }],
        version: [{ required: true, message: this.$t("validate.required"), trigger: "blur" }],
        remark: [{ required: true, message: this.$t("validate.required"), trigger: "blur" }],
      }
    },
  },
  mounted() {
    this.getFileFData()
  },
  methods: {
    // 获取文件类型数据
    async getFileFData() {
      try {
        let result = await this.$http.get(`/sys/dict/data/list?dataType=file_type`)
        this.fileTypeData = result.data.data ? result.data.data.map((item) => ({ value:item.dictValue, label: item.dictLabel })) : []
      } catch (error) {
        console.log(error)
      }
    },
    init() {
      this.visible = true
      this.$nextTick(() => {
        this.$refs["dataForm"].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo() {
      this.$http
        .get(`/loan/rduserupload/${this.dataForm.id}`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.dataForm = {
            ...this.dataForm,
            ...res.data,
          }
        })
        .catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
      function () {
        this.$refs["dataForm"].validate((valid) => {
          if (!valid) {
            return false
          }
          this.$http[!this.dataForm.id ? "post" : "put"]("/loan/rduserupload/", this.dataForm)
            .then(({ data: res }) => {
              if (res.code !== 0) {
                return this.$message.error(res.msg)
              }
              this.$message({
                message: this.$t("prompt.success"),
                type: "success",
                duration: 500,
                onClose: () => {
                  this.visible = false
                  this.$emit("refreshDataList")
                },
              })
            })
            .catch(() => {})
        })
      },
      1000,
      { leading: true, trailing: false }
    ),
  },
}
</script>
